import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Calendar, ArrowUp } from 'lucide-react';
import { CONTACT } from '../data';

export default function FloatingButtons() {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const fn = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3 items-end">
      {showTop && (
        <button
          data-testid="scroll-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white flex items-center justify-center hover:bg-white/20 transition-all"
          aria-label="Scroll to top"
        >
          <ArrowUp className="w-4 h-4" />
        </button>
      )}
      <a
        data-testid="floating-call"
        href={`tel:${CONTACT.phoneRaw}`}
        className="w-12 h-12 lg:w-auto lg:px-5 lg:gap-2 rounded-full bg-white text-black flex items-center justify-center lg:justify-start hover:bg-zinc-200 transition-all shadow-xl"
        aria-label="Call now"
      >
        <Phone className="w-4 h-4" />
        <span className="hidden lg:inline text-sm font-medium">Call</span>
      </a>
      <Link
        data-testid="floating-book"
        to="/book"
        className="px-5 h-12 rounded-full bg-blue-600 text-white flex items-center gap-2 hover:bg-blue-700 transition-all shadow-[0_8px_30px_rgba(37,99,235,0.5)]"
      >
        <Calendar className="w-4 h-4" />
        <span className="text-sm font-medium">Book Now</span>
      </Link>
    </div>
  );
}
